import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Bell, Loader2, AlertTriangle, ArrowRight } from "lucide-react";

const LEVEL = {
  danger: "border-danger/40 bg-danger/10 text-danger",
  warning: "border-warning/40 bg-warning/10 text-warning",
  success: "border-success/40 bg-success/10 text-success",
  info: "border-border bg-card text-muted-foreground",
};

export default function Notifications() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/notifications").then((r) => setData(r.data)); }, []);

  if (!data) return <div className="flex justify-center py-40"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>;

  const Row = ({ n }) => (
    <button data-testid={`alert-${n.id}`} onClick={() => n.idea_id && navigate(`/ideas/${n.idea_id}`)}
      className={`w-full text-left border rounded-sm p-3 flex items-center gap-3 hover:border-white/25 transition-colors duration-200 ${LEVEL[n.level] || LEVEL.info}`}>
      <AlertTriangle className="w-4 h-4 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm text-white font-medium">{n.idea_title}</p>
        <p className="text-xs">{n.message}</p>
      </div>
      <span className="font-mono text-[10px] text-muted-foreground whitespace-nowrap">{new Date(n.at).toLocaleDateString()}</span>
      <ArrowRight className="w-4 h-4 text-muted-foreground" />
    </button>
  );

  return (
    <div className="p-6 max-w-3xl">
      <header className="mb-6">
        <h1 className="font-heading text-4xl font-black tracking-tighter flex items-center gap-3">
          <Bell className="w-8 h-8 text-warning" /> Alerts & Bottlenecks
        </h1>
        <p className="text-sm text-muted-foreground mt-1">Live SLA breaches and pipeline events. Nothing sits stalled unnoticed.</p>
      </header>

      <section className="mb-8">
        <h3 className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-3">Live SLA / Bottleneck Alerts</h3>
        <div className="space-y-2">
          {data.alerts.map((n) => <Row key={n.id} n={n} />)}
          {data.alerts.length === 0 && <p className="text-sm text-muted-foreground">No active breaches. Pipeline is healthy.</p>}
        </div>
      </section>

      <section>
        <h3 className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-3">Recent Events</h3>
        <div className="space-y-2">
          {data.events.slice(0, 30).map((n) => <Row key={n.id} n={n} />)}
          {data.events.length === 0 && <p className="text-sm text-muted-foreground">No events yet.</p>}
        </div>
      </section>
    </div>
  );
}
